import { useEffect, useRef } from 'react'
import {
  AI_ONBOARDING_SELECTORS,
  destroyAIOnboardingTour,
  hasSeenAIOnboarding,
  isProductWalkthroughPending,
  startAIOnboardingTour,
} from '../utils/aiOnboarding'

export default function AIOnboardingTour({
  enabled,
  blocked,
  onOpenAssistant,
  pathname = '',
  resumeToken = 0,
}) {
  const startedRef = useRef(false)
  const onOpenAssistantRef = useRef(onOpenAssistant)
  onOpenAssistantRef.current = onOpenAssistant

  const openAndContinue = () => {
    if (onOpenAssistantRef.current) {
      onOpenAssistantRef.current({ continueOnboarding: true })
    }
  }

  useEffect(() => {
    if (blocked) destroyAIOnboardingTour()
  }, [blocked])

  useEffect(() => {
    if (pathname !== '/tutorial') return
    startedRef.current = false
    destroyAIOnboardingTour({ persistSeen: false })
  }, [pathname])

  useEffect(() => {
    if (!enabled || blocked || startedRef.current) return
    if (hasSeenAIOnboarding()) return
    if (isProductWalkthroughPending(pathname)) return

    let attempts = 0
    const timer = window.setInterval(() => {
      attempts += 1
      if (startedRef.current) {
        window.clearInterval(timer)
        return
      }
      if (!document.querySelector(AI_ONBOARDING_SELECTORS.headerButton)) {
        if (attempts >= 15) window.clearInterval(timer)
        return
      }
      window.clearInterval(timer)
      startedRef.current = true
      startAIOnboardingTour({
        onOpenAssistant: openAndContinue,
      }).catch(() => {
        startedRef.current = false
      })
    }, 300)

    return () => window.clearInterval(timer)
  }, [enabled, blocked, pathname])

  useEffect(() => {
    if (!enabled || blocked || !resumeToken) return
    if (isProductWalkthroughPending(pathname)) return

    const timer = window.setTimeout(() => {
      startAIOnboardingTour({
        force: true,
        startIndex: 1,
        onOpenAssistant: openAndContinue,
      }).catch(() => undefined)
    }, 400)

    return () => window.clearTimeout(timer)
  }, [enabled, blocked, pathname, resumeToken])

  useEffect(() => () => destroyAIOnboardingTour(), [])

  return null
}
